import { createTheme, ThemeProvider, Typography, Container, TextField } from '@material-ui/core';
import axios from 'axios';
import React from 'react';
import { useState, useEffect } from 'react';
import { CoinList } from '../../apis/api';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import LinearProgress from '@material-ui/core/LinearProgress';
import {makeStyles} from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import { Pagination } from '@material-ui/lab';

export function numberwithcommas(x){
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const useStyles = makeStyles(()=>({
    row:{
        backgroundColor: "#16171a",
        cursor: "pointer",
        "&:hover":{
            backgroundColor: "#131111"
        }
    },
    pagination:{
        "& .MuiPaginationItem-root":{
            color: "gold"
        }
    }
}));

function Coinstable() {
  const [coins, setcoins] = useState([]);
  const [loading, setloading] = useState(false);
  const [search, setSearch] = useState();
  const [page, setPage] = useState(1);
  const history = useNavigate();

  const fetchCoins = async ()=>{
    setloading(true);
    const {data} = await axios.get(CoinList('INR'));
    setcoins(data);
    setloading(false);
  }

  useEffect(() => {
    fetchCoins()
  }, [])

  let arr = ["Coin","Price","24h Change","Market Cap"];

  const darkTheme = createTheme({
    palette: {
        primary: {
            main: "#fff",
        },
        type: "dark",
    },
  });

  const handleSearch = ()=>{
    if(search==null){
        return (coins);
    }

    return coins.filter((coin)=>(
        coin.name.toLowerCase().includes(search) || coin.symbol.toLowerCase().includes(search)
    ))
  }

  const classes = useStyles();

  return (
    <ThemeProvider theme={darkTheme}>
        <Container>
            <Typography variant="h4" style={{margin:18,textAlign: "center",marginTop:30}}>
                Cryptocurrency Prices
            </Typography>

            <TextField 
            label="Search a currency..." 
            variant="outlined" 
            style={{marginBottom:20,width:"100%"}}
            onChange={(e)=>setSearch(e.target.value)}
            />

            <TableContainer>
                {loading?(
                    <LinearProgress style={{backgroundColor: "gold"}} />
                ) : (
                    <Table>
                        <TableHead style={{backgroundColor:"#eebc1d"}}>
                            <TableRow>
                                {
                                    arr.map((item)=>(
                                        <TableCell
                                            style={{color:"black",fontWeight:"700"}} key={{item}} 
                                            align={item==="Coin"?"":"right"}
                                        >
                                            {item}
                                        </TableCell>
                                    ))
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                                {handleSearch().slice((page-1)*10,(page-1)*10+10).map((row)=>{
                                    const profit = row.price_change_percentage_24h>0;

                                    return (
                                        <TableRow
                                        onClick={()=>history.push(`/coins/${row.id}`)}
                                        className={classes.row}
                                        key={row.id}
                                        >
                                            <TableCell component='th' scope='row' style={{
                                                display:"flex",gap:15,
                                            }}>
                                                    <img src={row.image} alt={row.name} height="50" 
                                                    style={{marginBottom:10}} />

                                                    <div style={{display:"flex",flexDirection: "column"}}>
                                                        <span style={{textTransform:"uppercase",fontSize:22,}}>
                                                            {row.symbol}
                                                        </span>
                                                        <span style={{color:"darkgrey"}}>{row.name}</span>
                                                    </div>
                                            </TableCell>
                                            <TableCell align='right'>
                                                Rs. {numberwithcommas(row.current_price.toFixed(2))}
                                            </TableCell>
                                            <TableCell align='right' 
                                            style={{
                                                color: profit>0?"rgb(14,203,129)":"red",
                                                fontWeight:500,
                                            }}
                                            >
                                                {profit && "+"} {row.price_change_percentage_24h?.toFixed(2)}%
                                            </TableCell>
                                            <TableCell align='right'>
                                                Rs. {numberwithcommas(row.market_cap.toString().slice(0,-6))}
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                        </TableBody>
                    </Table>
                )
                }
            </TableContainer>
            <Pagination
            style={{
                padding:20,
                width:"100%",
                display:"flex",
                justifyContent:"center",
            }}

            classes = {{ul:classes.pagination}}
            count={(handleSearch()?.length/10).toFixed(0)}
            onChange={(_,value)=>{
                setPage(value);
                window.scroll(0,450);
            }}
            />
        </Container>
    </ThemeProvider>
  )
}

export default Coinstable